<template>
  <mobile-screen :header="true" screen-class="gray-bg fluid help-screen">
    <template v-slot:header>
      <top-header-menu-wrapper menu-class="occupancy-header icon-hea1" :noHelp="true">
        <template v-slot:left>
          <router-link
            :to="{
              name: backLinkName,
              params: $route.params,
            }"
          >
            <icon icon="#cx-hea1-arrow-left" />
          </router-link>
        </template>
        <div class="component-title">
          {{ help[normalizedRoute]?.name || 'Help' }}
        </div>
      </top-header-menu-wrapper>
    </template>
    <section class="help-content-wrapper" v-if="help[normalizedRoute]?.content">
      <div v-html="help[normalizedRoute]?.content"></div>
    </section>
    <template v-slot:footer>
      <nav class="actions-menu theme-gray"></nav>
    </template>
  </mobile-screen>

  <router-view></router-view>
</template>

<script>
import MobileScreen from '@/layouts/MobileScreen';
import TopHeaderMenuWrapper from '@/components/global/TopHeaderMenuWrapper';
import { mapState } from 'vuex';

export default {
  name: 'HelpComponent',

  components: {
    MobileScreen,
    TopHeaderMenuWrapper,
  },

  props: {
    backLinkName: {
      type: String,
    },
    slug: {
      type: String,
    },
  },

  computed: {
    ...mapState('help', ['help']),

    normalizedRoute() {
      return this.$route.path
        .replace(/^\/|\/help$/g, '') // remove leading slash and trailing '/help'
        .split('/') // break into segments
        .filter((segment) => !/^\d+$/.test(segment)) // remove numeric segments
        .join('/'); // rejoin
    },
  },

  created() {
    this.$store.commit('global/setIsFullWidthScreen', true, { root: true });
  },
};
</script>
